
import { TimerType, TimerSettings } from './timerTypes';
import { audioManager } from '@/utils/audioManager';

// Get total time in seconds for the given timer type
export const getTotalTimeForType = (timerType: TimerType, settings: TimerSettings): number => {
  switch (timerType) {
    case 'pomodoro':
      return settings.pomodoro * 60;
    case 'shortBreak':
      return settings.shortBreak * 60;
    case 'longBreak':
      return settings.longBreak * 60;
    default:
      return 0;
  }
};

// Get timer title based on timer type
export const getTimerTitle = (timerType: TimerType): string => {
  switch (timerType) {
    case 'pomodoro':
      return 'Focus Time';
    case 'shortBreak':
      return 'Short break';
    case 'longBreak':
      return 'Long break';
    default:
      return '';
  }
};

// Calculate if a position in the sequence is a pomodoro or a break
export const isPomodoro = (position: number): boolean => {
  return position % 2 === 0;
};

// Calculate if a break should be a long break
export const isLongBreak = (position: number, sessions: number): boolean => {
  return position === sessions * 2 - 1;
};

// Play notification sound using the audio manager
export const playNotification = async () => {
  try {
    await audioManager.playSound('timer-complete');
  } catch (error) {
    console.warn('Failed to play notification sound:', error);
  }
};

// Play timer start sound
export const playTimerStart = async () => {
  try {
    await audioManager.playSound('timer-start');
  } catch (error) {
    console.warn('Failed to play timer start sound:', error);
  }
};

// Play timer pause sound
export const playTimerPause = async () => {
  try {
    await audioManager.playSound('timer-pause');
  } catch (error) {
    console.warn('Failed to play timer pause sound:', error);
  }
};

// Play timer reset sound
export const playTimerReset = async () => {
  try {
    await audioManager.playSound('timer-reset');
  } catch (error) {
    console.warn('Failed to play timer reset sound:', error);
  }
};

// Format time for browser tab title
export const formatTimeForDisplay = (timeLeft: number): string => {
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${formattedMinutes}:${formattedSeconds}`;
};

// Update browser tab title
export const updateDocumentTitle = (timeLeft: number, timerType: TimerType): void => {
  const formattedTime = formatTimeForDisplay(timeLeft);
  document.title = `${formattedTime} - ${getTimerTitle(timerType)}`;
};
